import { useMutation, useQueryClient } from '@tanstack/react-query'
import { transferServices } from '../transferServices'
import {
  SendConvertOrSellPayload,
  SendConvertOrSellDTO,
} from '../transferTypes'
import { useUserStore } from '@/store'
import { MUTATION_KEYS } from '@/constants/mutationKeys'

interface UseSendConvertOrSellOptions {
  onSuccess?: (data: { transaction_id: string }) => void
  onError?: (error: { errorMessage: string; code?: string }) => void
}

export const useSendConvertOrSell = (options?: UseSendConvertOrSellOptions) => {
  const queryClient = useQueryClient()
  const walletId = useUserStore((state) => state.wallet?.walletId)

  const mutation = useMutation<
    SendConvertOrSellDTO,
    Error,
    SendConvertOrSellPayload
  >({
    mutationFn: (data) =>
      transferServices.sendConvertOrSell({ ...data, wallet_id: walletId }),
    mutationKey: [MUTATION_KEYS.SEND_CONVERT_OR_SELL],
    onSuccess: (data) => {
      if (options?.onSuccess) {
        options.onSuccess({
          transaction_id: data.transaction_id,
        })
      }

      // Invalidate relevant queries
      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
      queryClient.invalidateQueries({
        queryKey: ['wallet'],
      })
    },
    onError: (err) => {
      if (options?.onError) {
        options.onError({
          errorMessage: err.message || 'Something went wrong',
        })
      }
    },
  })

  async function sendConvertOrSell(data: SendConvertOrSellPayload) {
    return mutation.mutateAsync(data)
  }

  return {
    sendConvertOrSell,
    isPending: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  }
}
